/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        // Enable Tooltips
        $('[data-toggle="tooltip"]').tooltip();

        // Smooth Scrolling        
        $('a[href*="#"]')
          .not('[href="#"]')
          .not('[href="#1-tab"]')
          .not('[href="#2-tab"]')
          .not('[href="#3-tab"]')
          .not('[href="#number-1"]')
          .not('[href="#number-2"]')
          .not('[href="#number-3"]')
          .not('[href="#0"]')
          .click(function(event) {
            
            // On-page links
            if (
              location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {

                var targetOffset = target.offset().top - 90;
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                  scrollTop: targetOffset,
                }, 1000, function() {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();
                  if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                    $target.focus();
                  }
                });
              }
            }
          });

        // Open Sidebar
        $(".global-header__menu-toggle").click(function(){
          $(".sidebar").css('right', 0);
        });

        // Close Sidebar
        $("#button-close-navigation").click(function(){
          $(".sidebar").css('right', '-100%');
        });

        // Cart dropdown
        $('#button-toggle-cart').click(function(){
          $('.cart-dropdown').slideToggle('fast');
        });

        // Brochure Download
        $('.-brochure-select__radio').click(function() {
          $('.brochure-post').hide();
          $('.brochure-download').hide();

          if($("#brochure-type-download").is(':checked')){          
            $('.brochure-download').show();            
          }

          if($("#brochure-type-post").is(':checked')){          
            $('.brochure-post').show();            
          }

          $('[data-fancybox]').fancybox({
            touch : false,
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home
    'home': {
      init: function() {

        // Header Slider
        $(".homepage__carousel").slick({
          slidesToShow: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 6000,
        });

        // Play the video in the slider
        function myHandler(e) {
          $('.homepage__carousel').slick('slickPlay');
        }

        $('.homepage__carousel').on('afterChange', function(event, slick, currentSlide){
          $('.homepage__carousel').slick('slickPause');          
            if(currentSlide === 3) {
              if ( $( "#video-slide" ).length ) {
                $('#video-slide').get(0).play();
              }
            } else {
              $('.homepage__carousel').slick('slickPlay');
            }
        });

        var videoSlide = document.getElementById("video-slide");
        if(videoSlide){
          document.getElementById("video-slide").addEventListener('ended', myHandler, false);
        }

        // Testimonial Slider
        $(".carousel-testimonials").slick({
          slidesToShow: 1,
          dots: false,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          autoplay: true,
          autoplaySpeed: 6000,
          arrows:true,
          infinite: true,
          nextArrow:'<button type="button" class="quote__next"></button>',
        });

        // Tabs
        
      }
    },
    // Furniture Range
    'furniture_range': {
      init: function() {
        $('.carousel').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          }]
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Craftsmanship
    'craftsmanship': {
      init: function() {

        $('#kaelo-ring-carousel').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          speed: 500,
          fade: true,
          cssEase: 'linear'
        });

        var videoPlayButton,
            videoWrapper = document.getElementsByClassName('video-wrapper')[0],
            video = document.getElementsByTagName('video')[0],
            videoMethods = {
              renderVideoPlayButton: function() {
                if (videoWrapper.contains(video)) {
                  this.formatVideoPlayButton();
                  video.classList.add('has-media-controls-hidden');
                  videoPlayButton = document.getElementsByClassName('video-overlay-play-button')[0];
                  videoSkipButton = document.getElementsByClassName('skip-video-button')[0];
                  videoPlayButton.addEventListener('click', this.hideVideoPlayButton);
                }
              },

              formatVideoPlayButton: function() {
                videoWrapper.insertAdjacentHTML('beforeend', '<div class="video-overlay-play-button"></div>');
              },

              hideVideoPlayButton: function() {
                video.play();
                videoPlayButton.classList.add('is-hidden');
                videoSkipButton.classList.add('is-hidden');
                video.classList.remove('has-media-controls-hidden');
                video.setAttribute('controls', 'controls');
              }
            };
            videoMethods.renderVideoPlayButton();
          }
      }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
